export default "__VITE_ASSET__34602103__"